import script from "./HeaderSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderSearch.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderSearch.vue?vue&type=style&index=0&id=e3303d1a&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3303d1a"]])

export default __exports__